import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const REVIEWS = [
  {
    quote:
      "Broke down on the I-10 with a loaded reefer trailer. Ray arrived with the heavy wrecker in under 30 minutes and Omar had the diagnostic completed that evening. Highest recommendation for any owner-operator.",
    author: "Carlos M.",
    title: "Owner-Operator, Freightliner Cascadia",
  },
  {
    quote:
      "GSX rebuilt the transmission on two of our fleet trucks. Flawless work, honest rates, and zero hassle. These guys are the real deal in Inland Empire.",
    author: "Dave R.",
    title: "Fleet Logistics Manager",
  },
];

export default function Testimonials() {
  return (
    <section className="relative py-24 bg-surface border-y border-steel" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-mono text-xs uppercase tracking-widest text-hazard font-semibold mb-12"
        >
          / 04 — Word From the Road
        </motion.p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={r.author}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="relative border border-steel bg-card p-8 hover:border-hazard/60 transition-colors duration-300"
              data-testid={`testimonial-card-${i}`}
            >
              <Quote className="w-8 h-8 text-hazard/40 mb-5" />
              <p className="text-slate-200 leading-relaxed text-base sm:text-lg">"{r.quote}"</p>
              <footer className="mt-6 pt-5 border-t border-steel flex items-center justify-between">
                <div>
                  <p className="font-heading font-bold uppercase text-lg text-white">{r.author}</p>
                  <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mt-1">{r.title}</p>
                </div>
                <span className="font-heading font-black text-4xl text-white/10 select-none">★★★★★</span>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
